.validateCodeContainer {
    margin-bottom: 14px;
}

.retrieveCodeMessage {
    font-size: 13px;
    color: #cacaca;
}
